<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import type { AvatarVariants } from "."
import { AvatarRoot } from "reka-ui"
import { cn } from "@/lib/utils"
import { avatarVariant } from "."
import { avatarIdentityStyle } from "@/lib/avatarIdentity"

const props = withDefaults(defineProps<{
  class?: HTMLAttributes["class"]
  size?: AvatarVariants["size"]
  shape?: AvatarVariants["shape"]
  // A person, company or crew id: hashes to one of the twenty identity hues,
  // with white initials. Absent → the single fallback token.
  identity?: string | null
}>(), {
  class: "",
  size: "sm",
  shape: "circle",
  identity: null,
})
</script>

<template>
  <AvatarRoot
    :class="cn(avatarVariant({ size, shape }), props.class)"
    :style="avatarIdentityStyle(identity) ?? undefined"
  >
    <slot />
  </AvatarRoot>
</template>
